module.exports = __webpack_public_path__ + "static/img/gdym02.c8c07ff.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/gdym02.png
// module id = r5+q
// module chunks = 0